import { logToSumoLogic } from "apis/sumoLogic";

const prefixXSellErrors = err => {
  if (!err) return;
  //if already prefixed
  if (err.message && /^XSELL:/.test(err.message)) return;

  if (err.stack && err.stack.includes("xsell-frontend.js")) {
    err.message = "XSELL: " + err.message;
  }
};

function consoleLogError(e) {
  (console.error || console.log).call(console, `Error: ${e.stack || e.message || e}`);
}

function logErrorToNewRelic(error) {
  // NewRelic script can be blocked by AdBlock etc
  if (!window.NREUM) return;
  window.NREUM.noticeError(error);
}

//Errors reported in our code should use this to report them
export function handleError(error, info) {
  prefixXSellErrors(error);
  consoleLogError(error);

  logErrorToNewRelic(error);
  try {
    logToSumoLogic(info ? { error, info } : error);
  } catch (e) {
    consoleLogError(e);
    logErrorToNewRelic(e);
  }
}

// All errors should otherwise be caught by new relic
// which uses this to ignore certain errors.
export function NewRelicErrorHandler(error) {
  prefixXSellErrors(error);
  // return true to skip error reporting
  return false;
}
